import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import ConsultantViewScreen from '../components/screens/consultants/ConsultantViewScreen';

export default function ConsultantsView(props) {
  return (
    <Layout headerTitle="Consultant View">
      <PageContainer id="consultant_view">
        <ConsultantViewScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
